import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const GetSubscriptionReducer: AppReducer<'GetSubscription'> = (
    state = InitialState.GetSubscription,
    action
): typeof state => {
    switch (action.type) {
        case 'GetSubscription/Started':
            return {
                ...state,
                getSubscriptionLinkLoading: true,
                getSubscriptionLinkSuccess: false,
            };

        case 'GetSubscription/Succeeded':
            return {
                ...state,
                getSubscriptionLinkLoading: false,
                getSubscriptionLinkSuccess: true,
                subscriptionUrl: action.payload.subscriptionUrl,
            };

        case 'GetSubscription/Failed':
            return {
                ...state,
                getSubscriptionLinkLoading: false,
                getSubscriptionLinkSuccess: false,
            };
        case 'GetSubscription/Unmounted':
            return {
                ...state,
                getSubscriptionLinkLoading: false,
                getSubscriptionLinkSuccess: false,
                errorCode: '',
            };


        case 'GetPartNumber/Started':
            return {
                ...state,
                getPartNumberLoading: true,
                getPartNumberSuccess: false,
            };

        case 'GetPartNumber/Succeeded':
            return {
                ...state,
                getPartNumberLoading: false,
                getPartNumberSuccess: true,
                partNumberData: action.payload.data,
            };

        case 'GetPartNumber/Failed':
            return {
                ...state,
                getPartNumberLoading: false,
                getPartNumberSuccess: false,
                // errorCode: action.payload.errorCode,
            };
        case 'GetPartNumber/Unmounted':
            return {
                ...state,
                getPartNumberLoading: false,
                getPartNumberSuccess: false,
                loading: false,
                success: false,
                // errorCode: '',
            };

        case 'CreateEntitlement/Started':
            return {
                ...state,
                entitlementLoading: true,
                entitlementSuccess: false,
            };

        case 'CreateEntitlement/Succeeded':
            return {
                ...state,
                entitlementLoading: false,
                entitlementSuccess: true,
            };

        case 'CreateEntitlement/Failed':
            return {
                ...state,
                entitlementLoading: false,
                entitlementSuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'CreateEntitlement/Unmounted':
            return {
                ...state,
                entitlementLoading: false,
                entitlementSuccess: false,
                loading: false,
                success: false,
                errorCode: '',
            };

        case 'MappingSiteIdActivationId/Started':
            return {
                ...state,
                mappingLoading: true,
                mappingSuccess: false,
            };

        case 'MappingSiteIdActivationId/Succeeded':
            return {
                ...state,
                mappingLoading: false,
                mappingSuccess: true,
                subscriptionType: action.payload.subscriptionType,
                quantity: action.payload.quantity,
                expirationDate: action.payload.expirationDate
            };

        case 'MappingSiteIdActivationId/Failed':
            return {
                ...state,
                mappingLoading: false,
                mappingSuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'MappingSiteIdActivationId/Unmounted':
            return {
                ...state,
                mappingLoading: false,
                mappingSuccess: false,
                loading: false,
                success: false,
                errorCode: '',
            };




        default:
            return state;
    }
};
